// AI-CONTEXT: See docs/features/household-overview-table-and-statuses.md
// Hoe lang een huishouden mag "lopen" voordat het op 'Onbereikbaar' gezet mag
// worden. Per tenant instelbaar via CompagnyMeta.UnreachableAfterDays.

/**
 * @typedef {object} WaitingPeriodOption
 * @property {number} value - Aantal dagen, zoals opgeslagen
 * @property {string} label - Wat de gebruiker leest
 */

/** @type {Array<WaitingPeriodOption>} */
const UNREACHABLE_AFTER_DAYS_OPTIONS = [7, 14, 30, 60].map((value) => ({
    value,
    label: `${value} dagen`,
}))

// Twee weken: ruim genoeg dat iemand die één belweek niet opnam nog niet
// afvalt, kort genoeg om de werkvoorraad niet te laten dichtslibben.
const UNREACHABLE_AFTER_DAYS_DEFAULT = 14

/**
 * Leest de tenantinstelling uit als een bruikbaar aantal dagen.
 *
 * Ontbrekende, lege of onzinnige waarden vallen terug op de standaard en
 * NOOIT op 0: elke tenant die de instelling nog niet gezien heeft zou anders
 * stilletjes het oude gedrag houden (drie pogingen en klaar), en dat is precies
 * wat deze wachttijd moet voorkomen.
 *
 * @param {*} value - Ruwe waarde van CompagnyMeta.UnreachableAfterDays
 * @returns {number} Aantal dagen, altijd groter dan 0
 */
const normalizeUnreachableAfterDays = (value) => {
    const days = Number(value)
    if (!Number.isFinite(days) || days <= 0) return UNREACHABLE_AFTER_DAYS_DEFAULT
    return days
}

export {
    UNREACHABLE_AFTER_DAYS_OPTIONS,
    UNREACHABLE_AFTER_DAYS_DEFAULT,
    normalizeUnreachableAfterDays,
}
